import { Controller } from "stimulus";
import { debounce, getCSRFToken } from "../../util";
import { GeckoPrimerInputError } from "../../events";

const ACTIVE_CLASSES = ["tw-underline", "tw-decoration-primary-500", "tw-decoration-2", "tw-underline-offset-2", "!tw-cursor-default"];

export default class extends Controller {
  static targets = [
    "signInTab", "signUpTab",
    "signInTitle", "signUpTitle",
    "signUpPassword", "signUpSubmit"
  ];

  /**
   * START: Modal content control (tabbed navigation, etc).
   */
  openSignInModal(e) {
    if (!this._hasAuthModalOnPage()) {
      return window.location = `/account/sign_in?locale=${I18n.locale}`;
    }

    this.updateTitle(e);
    this.signInTabTarget.click();
    Modal.show("auth_modal");
  }

  openSignUpModal(e) {
    if (!this._hasAuthModalOnPage()) {
      return window.location = `/account/sign_up?locale=${I18n.locale}`;
    }

    this.updateTitle(e)
    this.signUpTabTarget.click();
    Modal.show("auth_modal");
  }

  openResendConfirmationModal() {
    if (!this._hasAuthModalOnPage()) {
      return window.location = `/account/confirmation/new?locale=${I18n.locale}`;
    }

    Modal.show("resend_confirmation_modal");
  }

  openResetPasswordModal() {
    if (!this._hasAuthModalOnPage()) {
      return window.location = `/account/password/new?locale=${I18n.locale}`;
    }

    Modal.show("reset_password_modal");
  }

  updateTitle(e) {
    let signInTitle = e?.currentTarget?.dataset?.signInTitle;
    if (signInTitle) {
      this.signInTitleTarget.innerText = e?.currentTarget?.dataset?.signInTitle;
    }

    let signUpTitle = e?.currentTarget?.dataset?.signUpTitle
    if (signUpTitle) {
      this.signUpTitleTarget.innerText = e?.currentTarget?.dataset?.signUpTitle;
    }
  }

  _hasAuthModalOnPage() {
    return !!document.getElementById("auth-modal");
  }
  /**
   * END: Modal content control (tabbed navigation, etc).
   */


  /**
   * START: Sign up form validation
   */
  validate() {
    if (this.debouncedValidatePassword) {
      return this.debouncedValidatePassword();
    }

    this.debouncedValidatePassword = debounce(this._validatePassword, 300);
  }

  _validatePassword() {
    const params = {
      credentials: "same-origin",
      method: "POST",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": getCSRFToken() },
      body: JSON.stringify({ password: this.signUpPasswordTarget.value })
    };

    fetch(`/account/validate_password?locale=${I18n.locale || "en"}`, params)
      .then((response) => response.json())
      .then((data) => {
        this.signUpPasswordTarget.dispatchEvent(GeckoPrimerInputError(!!data["error_message"], data["error_message"]));
        window.passwordVerified = !!data["valid"];
        if (window.captchaVerified === true && window.passwordVerified === true) {
          this.signUpSubmitTarget.disabled = false;
        } else {
          this.signUpSubmitTarget.disabled = true;
        }
      });
  }
  /**
   * END: Sign up form validation
   */
}
